module.exports = __webpack_public_path__ + "LBP-Pro.svg?6312b6189531aafbaf5c43b2b3086198";